import ReactFlow, {
  ConnectionMode,
  ReactFlowProvider,
  Edge,
  NodeMouseHandler,
} from 'reactflow';
import React, { useEffect, useMemo } from 'react';
import { create } from 'zustand';
import {
} from '../ProductFlowMap/productFlowMap.util';
import CustomNode from './customNode';
import {
  generateColumnNodes,
  generateEdgesForNodes,
} from './getReactFlow.utils';
import {
  FlowNode ,
  NodeLabels ,
  NodesState,
} from '../ProductFlowMap/productFlowMap.types';

interface FlowState {
  nodes: FlowNode[];
  edges: Edge[];
  setNodes: (nodes: FlowNode[]) => void;
  setEdges: (edges: Edge[]) => void;
}

export const useFlowStore = create<FlowState>(set => ({
  nodes: [],
  edges: [],
  setNodes: nodes => set({ nodes }),
  setEdges: edges => set({ edges }),
}));

const numColumns = 4;

const GetReactFlow = (props: {
  containerWidth: number;
  containerHeight: number;
  nodesComponents: NodesState;
  handleNodeClick: NodeMouseHandler;
  isDownload?: boolean;
}) => {
  const {
    containerWidth,
    containerHeight,
    nodesComponents,
    handleNodeClick,
    isDownload,
  } = props;
  const columnWidth = containerWidth / numColumns;
  const columns = useMemo(() => {
    return Object.keys(nodesComponents).map((key, index) => {
      const columnNumber = index + 1;
      let previousNodes: NodeLabels[] = [];
      if (index == 1) {
        const previousKey = Object.keys(nodesComponents)[index - 1];
        previousNodes = nodesComponents[previousKey];
      }
      const data = generateColumnNodes(
        columnNumber,
        columnWidth,
        containerHeight,
        nodesComponents[key],
        previousNodes,
        isDownload
      );
      return data;
    });
  }, [nodesComponents]);

  const customNodeType = useMemo(() => {
    return {
      customNode: CustomNode,
    };
  }, [CustomNode]);

  const { nodes, setNodes, edges, setEdges } = useFlowStore();

  useEffect(() => {
    const allNodes = columns.flat();
    setNodes(allNodes);
  }, [columns, setNodes]);

  useEffect(() => {
    const allEdges = generateEdgesForNodes(columns);
    setEdges(allEdges);
  }, [columns, setEdges]);
  return (
    <ReactFlowProvider>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        fitView
        panOnDrag={false}
        maxZoom={1}
        minZoom={1}
        connectionMode={ConnectionMode.Strict}
        fitViewOptions={{
          padding: 0.5,
          nodes: columns.flat().map(item => ({ id: item.id })),
        }}
        nodeTypes={customNodeType}
        nodesDraggable={false}
        nodesConnectable={false}
        elementsSelectable={false}
        proOptions={{ hideAttribution: true }}
        onNodeClick={handleNodeClick}
      />
    </ReactFlowProvider>
  );
};

export default GetReactFlow;
